import "./scss/custom-bootstrap.scss";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Home from "./components/home/home";
import {
    CHOOSE_PLAN_ROUTE,
    CONTACT_US,
    DASHBOARD_ROUTE,
    FAIL_PAGE_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    FREE_ALERTS_BANNER,
    HOME_ROUTE,
    LOGIN_ROUTE,
    PAGE_NOT_FOUND_ROUTE,
    SETUP_ACCOUNT_STEP_ONE_ROUTE,
    SETUP_ACCOUNT_STEP_TWO_ROUTE,
    SIGNUP_ROUTE,
    SUCCESS_PAGE_ROUTE,
    SUPER_ADMIN_LOGIN_ROUTE,
    SUPER_ADMIN_OTP_ROUTE,
    TERMS_AND_CONDITIONS,
    TEST_ROUTE,
} from "./routes";
import ChoosePlan from "./components/choose-plan/choose-plan";
import Login from "./components/login/login";
import Signup from "./components/signup/signup";
import SetupAccountStep1 from "./components/setup-account/setup-account-step-1";
import ContactUs from "./components/contact-us/contact-us";
import SetupAccountStep2 from "./components/setup-account/setup-account-step-2";
import SuccessPage from "./components/success-page/success-page";
import FailPage from "./components/fail-page/fail-page";
import Dashboard from "./components/dashboard/dashboard";
import ForgetPassword from "./components/forget-password/forget-password";
import TermsAndCondition from "./components/terms-and-conditions/terms-and-condition";
import FreeAlertBanner from "./components/freeAlertsBanner/free-alert-banner";
import SuperAdminLogin from "./components/superadminLogin/superAdminLogin";
import SuperAdminOTP from "./components/superadmin-otp/superadmin-otp";
import PageNotFound from "./components/pageNotFound/page-not-found";
import Test from "./components/test";

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path={HOME_ROUTE} component={Home} />
                <Route exact path={CHOOSE_PLAN_ROUTE} component={ChoosePlan} />
                <Route exact path={LOGIN_ROUTE} component={Login} />
                <Route exact path={SIGNUP_ROUTE} component={Signup} />
                <Route exact path={SETUP_ACCOUNT_STEP_ONE_ROUTE} component={SetupAccountStep1} />
                <Route exact path={SETUP_ACCOUNT_STEP_TWO_ROUTE} component={SetupAccountStep2} />
                <Route exact path={CONTACT_US} component={ContactUs} />
                <Route exact path={SUCCESS_PAGE_ROUTE} component={SuccessPage} />
                <Route exact path={FAIL_PAGE_ROUTE} component={FailPage} />
                <Route path={DASHBOARD_ROUTE} component={Dashboard} />
                <Route exact path={FORGOT_PASSWORD_ROUTE} component={ForgetPassword} />
                <Route exact path={TERMS_AND_CONDITIONS} component={TermsAndCondition} />
                <Route exact path={FREE_ALERTS_BANNER} component={FreeAlertBanner} />
                <Route exact path={SUPER_ADMIN_LOGIN_ROUTE} component={SuperAdminLogin} />
                <Route exact path={SUPER_ADMIN_OTP_ROUTE} component={SuperAdminOTP} />
                <Route path={PAGE_NOT_FOUND_ROUTE} component={PageNotFound} />
                {/* <Route path={TEST_ROUTE} component={Test} /> */}
                <Redirect from="*" to={PAGE_NOT_FOUND_ROUTE} />
            </Switch>
        </Router>
    );
}

export default App;
